import React from "react";

function Case({ when, then, else: elsee }) {
    if (when) {
        return <React.Fragment> {then} </React.Fragment>;
    }
    return <React.Fragment> {elsee} </React.Fragment>;
}

export default Case;
